import { Badge } from '@ideon-api/ideon-ui'
import { FLAG_BADGE, isFlagCode, type FlagCode } from '../../lib/privileged-labels'

type Props = { flags: string[]; malformedIssuerIds: string[] }

export function CarrierFlags({ flags, malformedIssuerIds }: Props) {
  const known = flags.filter(isFlagCode)
  if (known.length === 0) return null

  const label = (flag: FlagCode): string => {
    if (flag !== 'malformed_issuer_id') return FLAG_BADGE[flag].label
    const n = malformedIssuerIds.length
    return `${n} malformed ID${n === 1 ? '' : 's'}`
  }

  return (
    <span className="flex flex-wrap gap-1">
      {known.map((flag) => (
        <Badge key={flag} variant={FLAG_BADGE[flag].variant} dot={false} uppercase={false}>
          {label(flag)}
        </Badge>
      ))}
    </span>
  )
}
